import { Component, OnInit } from '@angular/core';
import { Data, Router } from '@angular/router';

import { UtilsService } from 'src/app/services/utils.service';
import { InvoiceService } from 'src/app/services/invoice.service';
import { PrintService } from 'src/app/services/print.service';
import { CompanyService } from 'src/app/services/company.service';
import { Company } from 'src/app/models/company';
import * as xlsx from 'xlsx';

interface Filter {
  begDate: string,
  endDate: string,
  store: number //storeCode
}

@Component({
  selector: 'app-notes',
  templateUrl: './reprint-notes.component.html',
  styleUrls: ['../../../../app.component.scss'],
  providers: [UtilsService, PrintService, InvoiceService, CompanyService]
})

export class ReprintNotesComponent implements OnInit {
  public data: Data = {} as Data;
  public filter: Filter = {} as Filter;

  company = {} as Company;

  public certifier: number;
  public filer_note: string = '';
  public loading: boolean = false;
  public disabled: boolean = false;
  public reprint_note: string = '';
  public companyCode: number;

  // variables from data table
  public activeRow: any;
  public rows = new Array();
  public entries: number = 10;
  public noteList: any[] = new Array();

  public settings = {
    columns: {
      fecha: {
        title: 'Fecha'
      },
      autorizacionFactura: {
        title: 'No. de Autorización Factura'
      },
      correlativo: {
        title: 'Correlativo',
      },
      letra: {
        title: 'Letra'
      },
      nit: {
        title: 'Nit'
      },
      cliente: {
        title: 'Cliente',
      },
      clientDepartamento: {
        title: 'Departamento',
      },
      clientDistrito: {
        title: 'Distrito',
      },
      clientCiudad: {
        title: 'Ciudad',
      }
      ,
      Estado: {
        title: 'Estado DNIT',
      }
    }
  };

  constructor(
    public router: Router,
    private _utilsService: UtilsService,
    private _printService: PrintService,
    private _invoiceService: InvoiceService,
    private _companyService: CompanyService
  ) { }

  async ngOnInit() {
    const _data = JSON.parse(localStorage.getItem('data'));
    this.data.storeName = _data.storeName ? _data.storeName.toString() : null;
    this.data.storeCode = _data.storeCode ? parseInt(_data.storeCode.toString()) : 0;
    this.data.companyCode = _data.companyCode ? parseInt(_data.companyCode.toString()) : 0;
    this.companyCode = _data.companyCode ? parseInt(_data.companyCode.toString()) : 0;

    const urlTree = this.router.parseUrl(this.router.url);
    const location = urlTree.root.children.primary.segments[0].path;
    if (location === 'reprint-credit-note') {
      this.filer_note = 'NCRE';
      this.reprint_note = 'Nota de Crédito';
    } else {
      this.filer_note = 'NDEB';
      this.reprint_note = 'Nota de Debito';
    }
    const company = await this._companyService.getOne(this.data.companyCode);
    this.certifier = company.records[0].companyCertifier;

    this.filter.store = this.data.storeCode;
    this.filter.begDate = this._utilsService.dateTime('yyy-MM-dd');
    this.filter.endDate = this._utilsService.dateTime('yyy-MM-dd');

    await this.getCompany(this.companyCode);
  }

  ///////////////////////COMPANY///////////////////////
  getCompany(company) {
    return this._companyService.getOne(company).then(
      response => {
        if (response.result) {
          this.company = response.records[0];          
        } else {
          console.log(response.message);
        }
      },
      error => {
        console.log(error);
      }
    );
  }

  ///////////////////////FUNCIONES LIBRARY///////////////////////

  // DATA TABLE
  entriesChange($event) {
    this.entries = $event.target.value;
  }

  filterTable($event) {
    let val = $event.target.value.toLowerCase();
    this.rows = this.noteList.filter(function (d) {

      for (var key in d) {
        if (d[key] !== null) {
          if (d[key].toString().toLowerCase().indexOf(val) !== -1) {
            return true;
          }
        }
      }
      return false;
    });
  }

  onActivate(event) {
    this.activeRow = event.row;
  }

  // DOWNLOAD TABLE TO EXCEL
  // Exportar a excel
  // 1. Eliminar: Toda las propiedades que no se desee exportar.
  // 2. Convertir: Las propiedades a numericas. 
  // EJEMPLO:
  // for (const e of this.rows){
  //     delete e.eliminarElemento;
  //     e.convertirElemento = parseFloat(e.convertirElemento);
  //   }
  // this.excelServie.downloadToExcel(this.rows, 'Nombre del libro', 'nombre del reporte');

  downloadToExcel() {
    const checkList = this.rows;
      const exportFile = new Array<any>();
  
      checkList.forEach(element => {
        let json = {};
        Object.keys(this.settings.columns).forEach((item, index, arr) => {
          if (this.settings.columns[item].type === "number") {
            json[this.settings.columns[item].title] = parseFloat(element[item]);
          } else {
            json[this.settings.columns[item].title] = element[item];
          }
        });
        exportFile.push(json);
      });
      const ws: xlsx.WorkSheet =
        xlsx.utils.json_to_sheet(exportFile);
      const wb: xlsx.WorkBook = xlsx.utils.book_new();
      xlsx.utils.book_append_sheet(wb, ws, 'Reporte');
      xlsx.writeFile(wb, 'reporte-de-facturas.xlsx');
  }

  getAll(note) {
    if (this.filter.begDate != '' && this.filter.endDate != '') {
      this.loading = true;
      this.disabled = true;

      if (this.filer_note == 'NCRE') {
        this._invoiceService.getAllCreditNote(this.filter).then(
          (response) => {
            if (response.result == true) {
              this.noteList = response.records;
              this.rows = this.noteList;
              this._utilsService.showNotification(1, response.message);
            } else {
              this._utilsService.showNotification(3, response.errorMessage);
            }
          },
          error => {
            console.log(error);
            this._utilsService.showNotification(2, error);
          }
        ).finally(() => {
          this.loading = false;
          this.disabled = false;
        });
      } else {
        this._invoiceService.getAllDebitNote(this.filter).then(
          (response) => {
            if (response.result == true) {
              this.noteList = response.records;
              this.rows = this.noteList;
              this._utilsService.showNotification(1, response.message);
            } else {
              this._utilsService.showNotification(3, response.errorMessage);
            }
          },
          error => {
            console.log(error);
            this._utilsService.showNotification(2, error);
          }
        ).finally(() => {
          this.loading = false;
          this.disabled = false;
        });
      }

    } else {
      this.disabled = false;
      this._utilsService.showNotification(2, "Seleccionar una fecha");
    }
  }

  async reprint($event, note, format) {
    $event.preventDefault();
    this.loading = true;
    this.disabled = true;
    console.log('reprint', this.activeRow);

    if (format === 'PDF') {

      const bodyGetFile = {
        transmitter: {        
            transmitterPrefix: this.company.companyPrefix,        
            transmitterToken: this.company.companyToken              
        },    
        invoice: {
            invoiceCode: this.activeRow.id,
            cdc: this.activeRow.cdcnc,
            invoiceFormat: format,
            invoiceType: "notacredito"
        }
      }

      console.log('bodyGetFile GetFile->', bodyGetFile);

      this._invoiceService.getPDFMegaPY(bodyGetFile).then(
        async (response) => {
          console.log('response Get File', response);

          if(response.status){
            this._utilsService.showNotification(1, response.message);            
            const CDC = this.activeRow.cdcnc;
            this.downloadUrlS3(response.url, "notacredito-" + CDC, "pdf");
          }
          else{
            this._utilsService.showNotification(3, response.message);
          }
          
          this._utilsService.showNotification(1, "Factura Generada Correctamente");
        },
        error => {
          this._utilsService.showNotification(2, error);
          console.log(error);
        }
      ).finally(() => {
        this.disabled = false;
        this.loading = false;
      });

    }
    else{

      const bodyGetFile = {
        transmitter: {        
            transmitterPrefix: this.company.companyPrefix,        
            transmitterToken: this.company.companyToken              
        },    
        invoice: {
            invoiceCode: this.activeRow.id,
            cdc: this.activeRow.cdcnc,
            invoiceFormat: format,
            invoiceType: "notacredito"
        }
      }

      console.log('bodyGetFile GetFile->', bodyGetFile);

      this._invoiceService.getPDFMegaPY(bodyGetFile).then(
        async (response) => {
          console.log('response Get File', response);

          if(response.status){
            this._utilsService.showNotification(1, response.message);            
            const CDC = this.activeRow.cdcnc;
            this.downloadUrlS3(response.url, "notacredito-" + CDC, "xml");
          }
          else{
            this._utilsService.showNotification(3, response.message);
          }
          
          this._utilsService.showNotification(1, "Factura Generada Correctamente");
        },
        error => {
          this._utilsService.showNotification(2, error);
          console.log(error);
        }
      ).finally(() => {
        this.disabled = false;
        this.loading = false;
      });

    }
  }

  async downloadUrlS3(urlFirmada, nombreFile, format){
    const response = await fetch(urlFirmada);
    const blob = await response.blob();

    const urlBlob = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = urlBlob;
    link.download = nombreFile + "." + format;
    link.click();

    window.URL.revokeObjectURL(urlBlob);
  }

  downloadPdf(base64Data: string, fileName: string = 'factura.pdf') {
    // console.log('base64Data', base64Data);
    // Convertir base64 a un blob de tipo PDF
    const byteCharacters = atob(base64Data);
    const byteNumbers = Array.from(byteCharacters).map(char => char.charCodeAt(0));
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/pdf' });
  
    // Crear un link temporal y hacer clic para descargar
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = fileName;
    link.click();
  
    // Liberar memoria
    window.URL.revokeObjectURL(link.href);
  }

  goToResendXml($event: Event, row: any) {
    $event.preventDefault();
    this.router.navigate(['/xml-dnit-resend'], {
      state: { invoiceCode: row.id, typeDTE: 'NC', cdc: row.cdcnc }
    });
  }

  async getDnitStatus($event){
    $event.preventDefault();
    console.log('Consultando estado del DNIT para activeRow', this.activeRow);

    this.loading = true;

    const invoiceInfo = {
      lote: this.activeRow.lote
    }

    console.log('invoiceInfo para consulta DNIT', invoiceInfo);    

    this._invoiceService.getDNITStatus(invoiceInfo).then(
      async (response) => {
        console.log('response Get File', response);
        console.log('respuesta consulta lote', response.data.responseParsed.rResEnviConsLoteDe);

        if(response.data.responseParsed.rResEnviConsLoteDe.dCodResLot == "362"){          
          this._utilsService.showNotification(1, response.data.responseParsed.rResEnviConsLoteDe.dMsgResLot);

          if(response.data.responseParsed.rResEnviConsLoteDe.gResProcLote.gResProc.dCodRes == "260"){
            this._utilsService.showNotification(1, "Documento " + response.data.responseParsed.rResEnviConsLoteDe.gResProcLote.gResProc.dMsgRes + " por DNIT, Autorización: " + response.data.responseParsed.rResEnviConsLoteDe.gResProcLote.dProtAut);
            this.activeRow.estadodnit = "APROBADO";
          }
          else{
            this._utilsService.showNotification(2, "Documento " + response.data.responseParsed.rResEnviConsLoteDe.gResProcLote.gResProc.dMsgRes + " por DNIT");
            this.activeRow.estadodnit = "RECHAZADO - " + response.data.responseParsed.rResEnviConsLoteDe.gResProcLote.gResProc.dMsgRes;
          }
          
        }
        else if(response.data.responseParsed.rResEnviConsLoteDe.dCodResLot == "361"){
          this._utilsService.showNotification(2, "Lote en procesamiento");
          this.activeRow.estadodnit = "EN PROCESAMIENTO";
        }

      },
      error => {
        this._utilsService.showNotification(2, error);
        console.log(error);
      }
    ).finally(() => {      
      this.loading = false;
    });

  }

  ///////////////////////DESCARGAR XML FIRMADO///////////////////////
  downloadFunction($event: Event, noteAuthorization: string, noteCode: string) {
    $event.preventDefault();
    this.disabled = true;
    this.loading = true;

    //records: queryResult[0][1][0]['invoiceExchangeRegisterResponse']

    // if (this.company.companyCertifier == 1) { }
    this._invoiceService.xmlCreditNote(noteCode).then(
      async (response) => {
        if (response.result == true) {
          // const string = response.records[0].invoiceExchangeRegisterResponse;
          console.log(response)
          const xmlData = response.records;
          const xmlStart = xmlData.indexOf("<?xml");
          const xmlEnd = xmlData.indexOf("</dte:GTDocumento>") + 18;
          const xmlSubstring = xmlData.substring(xmlStart, xmlEnd);
          console.log(xmlSubstring);

          const dataXML = [xmlSubstring];
          const data = new Blob(dataXML, { type: 'text/xml' });

          const save = document.createElement('a');
          save.download = noteAuthorization;
          save.target = '_blank';
          save.href = URL.createObjectURL(data);

          var eventoClic = new MouseEvent('click', {
            'view': window,
            'bubbles': true,
            'cancelable': true
          });
          save.dispatchEvent(eventoClic);
          URL.revokeObjectURL(save.href);
        } else {
          this._utilsService.showNotification(3, response.errorMessage);
        }
      },
      error => {
        this._utilsService.showNotification(2, error);
        console.log(error);
      }
    ).finally(() => {
      this.disabled = false;
      this.loading = false;
    });


  }
}
